module.exports = __webpack_public_path__ + "static/img/autumn_banner.d3e68482.jpg";